<template>
    <app-modal :modal-id="modalId" modal-size="default" @close-modal="close">
        <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">{{ $t('post_update') }}</h5>
            <button type="button" class="close outline-none" @click.prevent="close">
               <span> <app-icon :name="'x'"></app-icon></span>
            </button>
        </template>
        <template slot="body">
            <new-post :edit-data="post" @update="update" />
        </template>
    </app-modal>
</template>

<script>
import NewPost from "./NewPost";
export default {
    props: ['modalId', 'id'],
    components: { NewPost },
    data(){
        return {}
    },
    methods: {
        close(){
            $('#post-edit-modal').modal('hide');
            this.$emit('close')
        },
        update(formData){
            this.$store.dispatch('posts/update', {formData, id: this.id}).then(res => {
                this.$toastr.s(res.data.message);
                this.close()
            }).finally(() => {})
        }
    },
    computed: {
        post(){
            return this.$store.getters['posts/post'](this.id)
        }
    }
}
</script>

<style scoped>

</style>